import React from "react"

import BackgroundImage from "gatsby-background-image"
import { useBackgroundImageQuery } from "../../queries/useBackgroundImageQuery"
const BackgroundImageHome = ({ image, classes }) => {
  const data = useBackgroundImageQuery()

  const imageData = data.allFile.edges.find(file => file.node.base === image)
    ?.node.childImageSharp.fluid

  if (imageData) {
    return (
      <BackgroundImage
        Tag="div"
        fluid={imageData}
        style={{
          width: "100%",
          height: "100%",
          backgroundPosition: classes?.backgroundPosition || "center center",
        }}
        backgroundSize={"contain"}
        backgroundRepeat={"no-repeat"}
      />
    )
  } else {
    return null
  }
}

export default BackgroundImageHome
